import axios from 'axios';
import constants from '../../config/constants';

export const GET_MY_BATCHES = 'GET_MY_BATCHES';
export const GET_MY_EXAMS = 'GET_MY_EXAMS';
export const GET_MY_EXAM_SUBJECTS = 'GET_MY_EXAM_SUBJECTS';
export const CLEAR_REDUCER = 'CLEAR_REDUCER';

export const GET_ALL_EXAMS = 'GET_ALL_EXAMS';
export const GET_EXAM = 'GET_EXAM';
export const GET_STUDENT_EXAM_MARK = 'GET_STUDENT_EXAM_MARK';
// Batch exams
export const GET_BATCH_EXAMS = 'GET_BATCH_EXAMS';
// Batch/Course exams
export const GET_BATCH_COURSE_EXAMS = 'GET_BATCH_COURSE_EXAMS';

// New exam flow
export const GET_ALL_EXAM_TYPES = 'GET_ALL_EXAM_TYPES';

// Reducer action creator
export const getMyBatches = data => ({
  type: GET_MY_BATCHES,
  batchData: data,
});

export const getMyExams = data => ({
  type: GET_MY_EXAMS,
  examData: data,
});

export const getMyExamSubjects = data => ({
  type: GET_MY_EXAM_SUBJECTS,
  subjectData: data,
});

export const clearReducer = () => ({
  type: CLEAR_REDUCER,
});

// Exams
export const getAllExams = guardians => ({
  type: GET_ALL_EXAMS,
  guardians,
});

export const getExam = exam => ({
  type: GET_EXAM,
  exam,
});

export const getStudentExamMark = marks => ({
  type: GET_STUDENT_EXAM_MARK,
  marks,
});

// Batch exams
export const getBatchExams = exams => ({
  type: GET_BATCH_EXAMS,
  exams,
});

// Batch/Couse exams
export const getBatchCourseExams = (batchCourseExams, mainExamType) => ({
  type: GET_BATCH_COURSE_EXAMS,
  batchCourseExams,
  mainExamType,
});

export const getAllExamTypes = examTypes => ({
  type: GET_ALL_EXAM_TYPES,
  examTypes,
});

// Action service call and dipatch
export const fetchAllExamTypeService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/exam-type-detail-by-batch/${data.batchId}`,
    constants.setHeader(data.token)
  );
  dispatch(getAllExamTypes(res.data));
  return res.data;
};

export const fetchMyBatchesService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/student/batch-details/${data.studentId}`,
    constants.setHeader(data.token)
  );
  dispatch(getMyBatches(res.data));
  return res.data;
};

export const fetchBatchOfExamService = data => async dispatch => {
  const { batchId, examType, token } = data;
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/subject-exam-detail-by-exam-type/${batchId}/${examType}`,
    constants.setHeader(token)
  );
  dispatch(getBatchCourseExams(res.data, examType));
  return res.data;
};

export const fetchMyExamsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/exam-type-detail-by-batch/${data.batchId}`,
      constants.setHeader(data.token)
    );
    dispatch(getMyExams(res.data));
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const fetchBatchExamsService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/student/exam-details-by-batch/${data.batchId}`,
    constants.setHeader(data.token)
  );
  dispatch(getBatchExams(res.data));
  return res.data;
};

export const fetchMyExamSubjectsService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/report/student-progress-report/${data.batchId}/${data.examTypeDetailId}/${data.studentId}`,
    constants.setHeader(data.token)
  );
  dispatch(getMyExamSubjects(res.data));
  return res.data;
};
//
// Exams
export const saveExamTypeService = data => () => {
  return axios.post(`${constants.API_BASE_URL}/api/exam-type-detail`, data.postData, constants.setHeader(data.token));
};

export const saveSubjectExamService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/subject-exam-detail`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const fetchExamService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/employee/get-exam-detail/${data.examId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getExam(res.data));
};

export const updateExamService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/employee/update-exam-detail/${data.examId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteExamService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/employee/delete-exam-detail/${data.examId}`,
    constants.setHeader(data.token)
  );
};

// Marks
export const saveMarkService = data => () => {
  let url = `/api/report/subject-mark`;
  if (data?.progReportId) {
    url = `/api/report/subject-mark/${data.progReportId}`;
  }
  return axios[data?.progReportId ? 'put' : 'post'](
    `${constants.API_BASE_URL}${url}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const updateMarkService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/report/subject-mark/${data.progReportId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const fetchStudentExamMarkService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/report/student-progress-report/${data.batchId}/${data.examTypeDetailId}/${data.studentId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getStudentExamMark(res.data));
};

// Plain (non-dispatching) variant - used by the bulk mark-entry modal to prefill existing marks
// for every student in a class for one subject exam in a single call, instead of one
// student-progress-report request per student.
export const fetchSubjectProgressReportApi = data => {
  return axios.get(
    `${constants.API_BASE_URL}/api/report/subject-progress-report/${data.batchId}/${data.examTypeDetailId}/${data.subjectId}`,
    constants.setHeader(data.token)
  );
};

export const deleteSubExamService = data => () => {
  const delType = data?.examSubjectDetailId
    ? `/api/subject-exam-detail/${data.examSubjectDetailId}`
    : `/api/exam-type-detail/${data.deleteMainExamId}`;
  return axios.delete(`${constants.API_BASE_URL}${delType}`, constants.setHeader(data.token));
};
